import React from "react";
import { useDispatch , useSelector  } from "react-redux";


import { useListmails , useUser } from "../../state/reactquery";
 

import { modifyDisplaymodal } from "../../state/redux";
import ListMails from "./ListMails";

import DivOneMail from "../../Ecrans/EcranEmails/DivOneMail";
import WindowMail from "./WindowMail";

import './MailingModal.scss' ; 

function MailingModal(){
    const dispatch = useDispatch() ; 
    const {data: user} = useUser(localStorage.getItem('token'))  ;
    const leadactu = useSelector(state=>state.lead.leadactu);
    const {data: messages} = useListmails(user?.postmail,leadactu?.email) ;

    const {typemail , emailchoice} = useSelector(state=>state.email);
    const ecran = useSelector(state=>state.display.ecran) ;

    const emailto = ecran===('gestiontoclient' || ecran==='comtoclient' ) ? (emailchoice?.emailFrom?.includes('@mutuello.') ? emailchoice?.emailTo : emailchoice?.emailFrom) : leadactu?.email ;

 

        return(<div className="containergray"> 
                    <div className="displayflexcenter" >
                      {typemail==='transfer'?<></>:
                      ecran==='ecranemails'?<DivOneMail />:  <ListMails  messages={messages}  />}
                                           <WindowMail widthsize="wd600" emailTo={emailto} leadactu={leadactu} closewindow={()=>dispatch(modifyDisplaymodal(null))   }  />
                    </div>   
                </div>);

}


export default MailingModal